import { ActivatedRouteSnapshot, UrlSegment } from '@angular/router';
import { defaultLocale } from './build-locale';
import { extractLanguageFromPath } from './locale-extract';

const getPath = (route: ActivatedRouteSnapshot) => {
  let path: string[] = route.url.map(u => u.path);
  if (!path.length && route.routeConfig?.path) {
    const configPath = route.routeConfig.path;
    if (!configPath.includes(':') && !configPath.includes('**')) {
      path = [route.routeConfig.path];
    }
  }
  if (route.firstChild) {
    const childPath = getPath(route.firstChild);
    if (childPath) path = path.concat(...childPath);
  }
  return path;
};

export const filterPath = (path: string[]) => {
  const last = path[path.length - 1];
  if (last && last.match(/^page-\d+$/)) {
    path.pop();
  }
  return path;
};

export const getFullPath = (route: ActivatedRouteSnapshot, removePageParam = true, removeLangParam = true) => {
  const path = getPath(route.root);
  const lang = extractLanguageFromPath(path);
  if (removeLangParam && lang && path[0]?.toLowerCase().startsWith(lang.toLowerCase())) {
    path.shift();
  }

  if (removePageParam) {
    return filterPath(path);
  }

  return path.filter(Boolean);
};

export const getFullPathFromUrlSegments = (
  urlSegments: UrlSegment[],
  removeLangParam: boolean,
  currentLocale: string
) => {
  const segments = urlSegments.filter(Boolean);
  const path = filterPath(segments.map(segment => segment.path));
  if (!removeLangParam && currentLocale !== defaultLocale) {
    path.unshift(currentLocale);
  }
  return path.filter(Boolean);
};
